<template>
  <el-dialog :title="title" :visible="show" class="pop-send-code-dialog" width="356px" @close="onClose">
    <div class="content">
      <div class="info">
        <img class="info-img" src="@/assets/img/icon_info.png" />
        <div class="info-text">{{ info }}</div>
      </div>
      <div>
        <div class="send-header">
          <div class="title" :style="btnDisabled ? '' : 'margin-bottom:8px;'">输入验证码</div>
          <div class="desc" v-if="btnDisabled">验证码已发送至 {{ mobile }}</div>
        </div>
        <div class="send-code">
          <div class="pop-send-code__input-wrap">
            <div
              class="pop-send-code__input"
              :class="{ 'pop-send-code__input--active': !isFirst && val.length === 0 }"
              @click="onFocus"
              :value="v1"
            >
              {{ v1 }}
            </div>
            <div
              class="pop-send-code__input"
              :class="{ 'pop-send-code__input--active': !isFirst && val.length === 1 }"
              @click="onFocus"
              :value="v2"
            >
              {{ v2 }}
            </div>
            <div
              class="pop-send-code__input"
              :class="{ 'pop-send-code__input--active': !isFirst && val.length === 2 }"
              @click="onFocus"
              :value="v3"
            >
              {{ v3 }}
            </div>
            <div
              class="pop-send-code__input"
              :class="{ 'pop-send-code__input--active': !isFirst && val.length === 3 }"
              @click="onFocus"
              :value="v4"
            >
              {{ v4 }}
            </div>
          </div>
          <input ref="input" type="number" class="pop-send-code__input-hid" :value="val" @input="onChange" />
        </div>
        <div v-show="!pass" class="error">验证码错误，请重新输入</div>
        <div class="send-footer">
          <el-button type="primary" :disabled="btnDisabled" @click="onSendCode">{{ btnText }}</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Fetch from '@/api';
import { Util } from '@/util';
let timer;
export default {
  props: {
    title: String,
    mobile: String,
    info: String,
    type: {
      type: Number,
      default: 2
    },
    second: {
      type: Number,
      default: 60
    },
    title: {
      type: String,
      default: '实名验证'
    },
    show: Boolean
  },
  data() {
    return {
      val: '',
      sec: 60,
      btnDisabled: false,
      isFirst: true,
      pass: true
    };
  },
  computed: {
    v1() {
      return this.val[0] || '';
    },
    v2() {
      return this.val[1] || '';
    },
    v3() {
      return this.val[2] || '';
    },
    v4() {
      return this.val[3] || '';
    },
    btnText() {
      return this.btnDisabled ? `重新发送(${this.sec}s)` : '发送验证码';
    }
  },
  created() {
    this.sec = this.second;
  },
  beforeDestroy() {
    clearInterval(timer);
  },
  methods: {
    reset() {
      clearInterval(timer);
      this.val = '';
      this.sec = this.second;
      this.btnDisabled = false;
      this.isFirst = true;
      this.pass = true;
    },
    onClose() {
      this.$emit('close');
      this.$nextTick(() => {
        this.reset();
      });
    },
    onFocus() {
      this.$refs.input.focus();
    },
    async onChange(e) {
      let val = e.target.value;
      this.val = val;

      this.val = this.val.replace(/[^\d]/g, '').substr(0, 4);

      if (this.val.length === 4) {
        if (this.isFirst) {
          this.$message.info('请先获取验证码');
          return;
        }
        let pass = await Fetch.checkVerifyCodeAndSave({
          verifyCode: this.val,
          mobile: this.mobile,
          type: this.type,
          prescriptionSource: 2
        });
        this.pass = pass;
        if (!pass) return;
        clearInterval(timer);
        this.$emit('success');
      }
    },
    onSendCode() {
      Util.submitOnce(this._sendCode);
    },
    async _sendCode() {
      await Fetch.send_verify_code_by_type({ mobile: this.mobile, type: this.type });
      this.isFirst = false;
      this.btnDisabled = true;
      this.onFocus();
      timer = setInterval(() => {
        if (this.sec === 1) {
          clearInterval(timer);
          this.btnDisabled = false;
          this.sec = this.second;
        }
        this.sec--;
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.pop-send-code-dialog {
  /deep/ .el-dialog__header {
    padding: 20px;
    padding-bottom: 10px;
  }
  /deep/ .el-dialog__body {
    padding: 0 20px;
    padding-bottom: 10px;
  }
  /deep/.el-dialog__headerbtn {
    display: block !important;
  }
}

.content {
  .info {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff8200;
    display: flex;
    padding: 12px 16px;
    background: #fff7e6;

    .info-img {
      width: 16px;
      height: 16px;
    }
    .info-text {
      flex: 1;
      line-height: 16px;
      margin-left: 4px;
    }
  }
  .send-header {
    margin-top: 16px;
    .title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #262626;
    }
    .desc {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8c8c8c;
      margin-bottom: 8px;
      margin-top: 4px;
      min-height: 18px;
    }
  }
  .send-code {
    height: 52px;
    .pop-send-code__input-wrap {
      display: flex;
      justify-content: space-between;
      height: 52px;
    }
    .pop-send-code__input {
      width: 52px;
      height: 52px;
      line-height: 52px;
      text-align: center;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #d9d9d9;
      box-sizing: border-box;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
    }
    .pop-send-code__input-hid {
      width: 0;
      height: 0;
      margin: 0;
      border: none;
      outline: none;
    }
    .pop-send-code__input--active {
      border: 1px solid #1e8dff;
    }
  }
  .error {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff4e47;
    margin: 4px 0;
    height: 18px;
    line-height: 18px;
  }
  .send-footer {
    margin-top: 12px;
    .el-button {
      width: 100%;
    }
    .is-disabled {
      border-color: #ebeef5;
    }
    .is-disabled:hover {
      cursor: not-allowed;
      background-color: #e6e6e6;
      border-color: #ebeef5;
    }
  }
}
</style>
